import { useWatch } from "react-hook-form";
import { SegmentedControl } from "./SegmentedControl.jsx";

const doubleSiteOptions = [
  { value: "any", label: "Either" },
  { value: "double", label: "Double" },
  { value: "single", label: "Single" },
];

// Site types that support the double site filter
const validSiteTypes = ["rv", "tent"];

export function DoubleSiteInput({ name, facility, formContext, ...rest }) {
  const { control } = formContext;
  const siteType = useWatch({ name: "siteType", control });

  if (!siteType || !validSiteTypes.includes(siteType)) {
    return null;
  }

  // Only show when facility has at least one double site of this type
  const hasDoubleSites = facility.sites
    .filter((site) =>
      siteType === "rv" || siteType === "tent"
        ? site.type.includes(siteType)
        : site.type === siteType,
    )
    .some((site) => site.isDoubleSite);

  if (!hasDoubleSites) {
    return null;
  }

  return (
    <SegmentedControl
      control={control}
      name={name}
      label="Do you want a double site?"
      options={doubleSiteOptions}
      size="sm"
      {...rest}
    />
  );
}
